module.exports = __webpack_public_path__ + "static/media/Outdoors Tree Valley.e6f7203b.svg";